const images = document.querySelectorAll('.scroll-image');

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry, index) => {
    if (entry.isIntersecting) {
      const el = entry.target;
      // Add a small delay based on index for staggered effect
      setTimeout(() => {
        el.classList.add('visible');
      }, index * 150); // 150ms delay between items
      observer.unobserve(el); // Optional: animate only once
    }
  });
}, {
  threshold: 0.2
});

images.forEach(img => observer.observe(img));
